import type { StaticLayerPayload } from "@config";
import { ButtonLibrary } from "@library-elements/button";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: ButtonLibrary,
};

export const Button = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
